<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="full-height-withheader">
    <div class="px-5 py-4 border-bottom border-gray bg-lighter">
        <div class="content-wrapper">
            <button class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal"
                [routerLink]="'../../'" i18n>
                <i class="ni ni-bold-left mr-1"></i> Back
            </button>
            <div class="d-flex justify-content-between">
                <h2 class="display-2" i18n>Edit Statement</h2>
            </div>
        </div>
    </div>
    <div class="p-5 mb-4 border-bottom flex-1">
        <div class="content-wrapper">
            <app-policy-statement-card *ngFor="let statement of (statementSelections$ | async); index as idx; trackBy:trackByStatementIdx"
                [statement]="statement" [showCancelButton]="false" [statementIdx]="idx">
            </app-policy-statement-card>
        </div>

    </div>

    <div class="d-flex mb-3 px-5">
        <div class="content-wrapper d-flex justify-content-between width-100">

            <button class="btn btn-outline-default" routerLink="../../">
                <span class="btn-inner--text" i18n>Cancel</span>
            </button>

            <button class="btn btn-info" (click)="submit()">
                <span class="btn-inner--text" i18n>Save Changes</span>
            </button>

        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/policy-details/policy-statements-list/policy-statement-edit/policy-statement-edit.component.html